import * as io from "io-ts";

export const ChartBlockResolver = io.type({
  size: io.number,
  title: io.union([io.string, io.null]),
});
export type ChartBlock = io.TypeOf<typeof ChartBlockResolver>;
